<template>
    <div class="investigation_wrap">
        <!-- 顶部条状栏目 -->
        <div class="top flex-between">
            <div class="left_bar">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item><i class="iconfont icon-gongbudaan" >&nbsp;问卷列表</i></el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div>
                <i @click="isInvestigationContent = false" v-show="isInvestigationContent" class="iconfont icon-arrowLeft">&nbsp;返回</i>
            </div>
        </div>
        <!-- 列表为空 -->
        <div class="empty-wrap mat10" v-if="investigationList.length == 0">
            <img src="../../assets/img/offshelf.png" alt="">
        </div>
        <!-- 问卷调查列表 -->
        <div class="investigation_content" v-if="!isInvestigationContent">
            <div class="investigation_item flex-between" v-for="item in investigationList" :key="item.id">
                <div class="item_left">
                    <div class="item_title">{{item.title}}</div>
                    <div class="item_publisher">发布人：{{item.username}}</div>
                    <div class="end_time">问卷截止时间：{{item.stopTime}}</div>
                </div>
                <div @click="getSurveyContent(item)" class="item_right flex-justify-content button-hover" :style="item.isSubmit ? 'background:#F1F3F4' : ''">
                    <div class="icon_button">
                        <div>
                            <i class="iconfont icon-tianxiegongdan-kuozhan-hebing"></i>
                        </div>
                        <div>填写问卷</div>
                    </div>
                </div>
            </div>
            <!-- 问卷列表分页 -->
            <div class="flex-around mat20">
                <el-pagination  background :page-size="5"  layout="prev, pager, next"  @current-change="getInvestigationList" :current-page.sync="pages.currentPage" :total="pages.totals"></el-pagination>
            </div>
        </div>
        <!-- 问卷调查表单 -->
        <div class="investigation_form" v-else>
            <div v-for="(question,index) in surveyContentList" :key="question.id">
                <!-- 单选列表 -->
                <div class="question_item" v-if="question.type == 1">
                    <div class="question_title">{{index + 1}}.{{question.title}}</div>
                    <el-radio-group class=" question_option" v-model="question.optionId">
                      <el-radio v-for="item in question.options" :key="item.id" :label="item.id">{{item.title}}</el-radio>
                    </el-radio-group>
                </div>
                <!-- 评价文本框 -->
                <div v-if="question.type == 2">
                    <div class="evaluate_title">*请针对MS学习平台的使用体验编写不小于20字的评价。</div>
                    <el-input  type="textarea" show-word-limit maxlength="1000" :autosize="{ minRows: 4 }" placeholder="请输入评价内容"  v-model="question.content"></el-input>
                </div>
            </div>

            <!-- 提交问卷 -->
            <div class="flex-around commit_button">
                <el-button type="primary" @click="commitSurvey">提交问卷</el-button>
            </div>
        </div>

    </div>
</template>
<script>
import { previewSurvey, surveyList, writeSurvey } from '../../utils/api';

export default {
    data() {
        return {
            radio: '',
            evaluateText: '',
            surveyId: '',
            classId: '',
            isInvestigationContent: false,
            investigationList: [],
            surveyContentList: [],
            pages: {
                    currentPage:1,
                    totals:1
                },
            }
        },
        created(){
            this.getInvestigationList()
        },
        methods:{
            //填写问卷
            commitSurvey(){
                let params = {
                    surveyId:this.surveyId,
                    classId:Number(this.classId),
                    answers:this.surveyContentList.map(item => {
                        return {
                            itemId:item.id,
                            optionId:item.optionId,
                            content:item.content
                        }
                    }),
                }
                writeSurvey(params).then(res => {
                    this.$message.success('问卷提交成功！')
                    this.isInvestigationContent = false
                    this.getInvestigationList()
                }).catch(err => {})
            },

            //获取问卷调查内容
            //id为问卷类型id，surveyId为当前问卷id
            getSurveyContent(item){
                if(item.isSubmit) return this.$message.warning('该问卷已提交')
                this.surveyId = item.id
                this.classId = item.classId
                this.isInvestigationContent = true
                previewSurvey({questionnaireId:item.questionnaireId}).then(res => {
                    this.surveyContentList = res.data.items
                }).catch(err => {})
            },

            //获取调查问卷列表
            getInvestigationList(){
                let params = {
                    keyword:'',
                    page:this.pages.currentPage,
                    size:5
                }
                surveyList(params).then(res => {
                    this.investigationList = res.data.list
                    this.pages.totals = res.data.totalCount
                }).catch(err => {})
            }
        },
    }
</script>
<style lang='scss' scoped>
.empty-wrap{
    background: white;
}
.commit_button{
    margin: 20px 0px;
}
.investigation_form{
    background: white;
    margin-top: 10px;
    box-sizing: border-box;
    padding: 50px 140px;
    .evaluate_title{
        line-height: 1.7;
        color: #001E84;
        font-size: 19px;
        margin-bottom: 10px;
        font-weight: 550;
        font-family: 'Microsoft YaHei';
    }
    .question_item{
        margin: 10px 0px;
        .question_title{
            font-size: 19px;
            color: #001E84;
            font-weight: 550;
            font-family: 'Microsoft YaHei';
            line-height: 1.7;
        }
        .question_option{
            /deep/.el-radio{
                margin: 20px 80px 20px 0px;
            }
            /deep/.el-radio__label{
                font-size: 16px;
                color: #001E84;
            }
        }
    }
}
.investigation_content{
    padding-bottom: 60px;
    .investigation_item{
        position: relative;
        box-shadow: 0px 3px 6px #E2E2E2;
        .item_left{
            padding: 30px 35px;
            color: #001E84;
            .item_title{
                font-weight: bold;
                font-size: 25px;
                margin-bottom: 15px;
            }
            .end_time{
                color: #F56C6C;
                margin-top: 8px;
            }
        }
        .item_right{
            width: 140px;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            height: 100%;
            background: #E4F6FF;
            .icon_button{
                text-align: center;
                font-size: 18px;
                color: #001E84;
                i{
                    font-size: 25px;
                    margin-bottom: 10px;
                    font-weight: 500;
                }
            }
        }
    }

}
.investigation_item{
    margin-top: 10px;
    box-sizing: border-box;
    background: white;
}
.collect_wrap{
    padding-bottom: 50px;
    .empty-wrap{
        background: white;
        margin-top: 10px;
    }
}
.top{
    height: 55px;
    box-sizing: border-box;
    background: white;
    box-sizing: border-box;
    margin-top: 15px;
    padding: 0px 50px 0px 0px;
    color: #848484;
    .left_bar{
        min-width: 100px;
        // max-width: 250px;
        /deep/.el-breadcrumb__inner{
            line-height: 55px;
            font-size: 17px;
            color: white;
        }
        .icon-shoucangjia{
            color: white;
        }
        height: 55px;
        padding: 0px 50px;
        background: url(../../assets/img/collectBar.png) 0 0/100% 100% no-repeat;
    }
}
</style>
